<template>
  <v-btn
    v-if="variant === 'primary'"
    icon
    :class="[color, 'primary--text rounded-lg']"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-icon v-if="icon">{{ icon }}</v-icon>
  </v-btn>
  <v-btn v-else icon outlined :class="['secondary--text rounded-lg']" v-bind="$attrs" v-on="$listeners">
    <v-icon v-if="icon">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true },
    color: { type: String, default: 'secondary' },
    variant: { type: String, default: 'primary' },
  },
}
</script>
